"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NULL_PUBKEY = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.NULL_PUBKEY = new web3_js_1.PublicKey("1nc1nerator11111111111111111111111111111111");
